angular.module("avant.customer_applications.controllers").controller "CustomerApplicationsDeclinedCtrl", [
  "$controller",
  "$location",
  "$sce",
  "$scope",
  "$window",
  "ApplicationService",
  "CustomerApplicationService",
  "HardSecuredService",
  "ConfigService",
  "progress",
  ($controller, $location, $sce, $scope, $window, ApplicationService, CustomerApplicationService, HardSecuredService, ConfigService, progress) ->
    $scope.page = "declined"
    $scope.$emit('customer_application:data', ApplicationService.data)
    angular.extend($scope, $controller('CustomerApplicationsMixinCtrl', {$scope: $scope}))

    $scope.loading = true
    $scope.declined_message = ApplicationService.message
    $scope.requirements ||= {}

    $scope.partnerImgUrl =
      amone: require('@amount/frontend-styles/src/images/logo/partner-logos/amone.svg')
      avant_card: require('@amount/frontend-styles/src/images/dec/dec-creditcard-avant-cloud.svg')
      avant_deposit: require('@amount/frontend-styles/src/images/dec/dec-avantdebitcard-blue-logo.png')
      card_ratings_com: require('@amount/frontend-styles/src/images/logo/logo-card_ratings_com.png')
      credible: require('@amount/frontend-styles/src/images/logo/logo-credible.svg')
      elastic: require('@amount/frontend-styles/src/images/logo/partner-logos/elastic.jpg')
      elastic_card: require('@amount/frontend-styles/src/images/logo/partner-logos/elastic.jpg')
      eloan_avant_post: require('@amount/frontend-styles/src/images/logo/logo-avant.svg')
      eloan_to_avant: require('@amount/frontend-styles/src/images/logo/logo-avant.svg')
      forward_line: require('@amount/frontend-styles/src/images/logo/partner-logos/forward-line.jpg')
      fundera: require('@amount/frontend-styles/src/images/logo/partner-logos/fundera.jpg')
      hsbc_avant_prefill: require('@amount/frontend-styles/src/images/logo/logo-avant.svg')
      lending_tree: require('@amount/frontend-styles/src/images/logo/partner-logos/lending-tree.jpg')
      on_deck: require('@amount/frontend-styles/src/images/logo/partner-logos/on-deck.png')
      opp_loans: require('@amount/frontend-styles/src/images/logo/partner-logos/opp-loans.jpg')
      regions: require('@amount/frontend-styles/src/images/partners/regions/logo/logo-regions.svg')
      regions_avant_decline: require('@amount/frontend-styles/src/images/partners/regions/logo/logo-regions-plus-avant.svg')
      regions_avant_post: require('@amount/frontend-styles/src/images/logo/logo-avant.svg')
      rise_credit: require('@amount/frontend-styles/src/images/logo/partner-logos/rise-credit.jpg')
      sofi: require('@amount/frontend-styles/src/images/logo/partner-logos/sofi.jpg')

    $scope.partnerImgAltText =
      hsbc_avant_prefill: 'Avant'

    # This may be overwritten in the partner specific controller
    $scope.tealiumDeclineTagName = ->
      "#{$scope.page}_view"

    # This may be overridden in the partner specific controller
    $scope.setDeclinePageTitle = ->

    hasHardSecuredPartnerCode = ->
      _.contains(
        _.map($scope.declinedOptions, (v) -> v.partner_offer?.partner_code),
        'hard_secured')

    $scope.submit = ->
      return unless hasHardSecuredPartnerCode()
      $scope.$emit "submitDisabled", true
      HardSecuredService.convertApplication().then (url) ->
        $scope.openUrl url

    $scope.viewSmallCardOffer = ($event, declinedOption) ->
      declinedOption.template = 'card_hero'

    $scope.markOfferViewed = (viewMarkedLink) ->
      CustomerApplicationService.markOfferViewed(viewMarkedLink) # Not yet implemented

    $scope.trustAsHtml = (html) ->
      $sce.trustAsHtml html

    $scope.hasCustomHtml = (str) ->
      /<[a-z][\s\S]*>/i.test(str)

    $scope.hasPiiCheckbox = (declinedOption) ->
      return (declinedOption.data.partner_code == 'amone' || declinedOption.data.partner_code == 'rise_credit')

    $scope.openNoaaInNewTabAndPrint = ->
      w = $scope.openUrl $scope.viewNoaaUrl, true

      # Supporting multiple browsers to make sure the page is rendered before calling print()
      #
      # Chrome
      if w.addEventListener
        w.addEventListener 'load', ->
          w.print()
        , false
      # IE 11
      else if w.attachEvent
        w.attachEvent 'onload', ->
          w.print()
      # Legacy browsers
      else if w.onLoad
        console.log('on Load')
        w.onload = w.print()

    $scope.openUrl = (url, newTab = false) ->
      if newTab then $window.open(url) else $window.location.replace(url)

    # Replaces the deprecated `viewPartnerOffer` function
    $scope.viewPartnerOfferAndRedirect = ($event, declinedOption, shouldOpenNewWindow) ->
      return unless declinedOption
      redirectLink = declinedOption.data.initial_redirect_link
      redirectLink += "?share_pii=#{!!$scope.prefillConsents[declinedOption.data.partner_offer_id]}"
      # TODO: address the following console error resulting from the following lines of code:
      # Error: [$parse:isecwindow] Referencing the Window in Angular expressions is disallowed! Expression: viewPartnerOfferAndRedirect($event, declinedOption, true)
      $scope.openUrl redirectLink, shouldOpenNewWindow
      return true # this is necessary to prevent coffee from returning a DOM element which Angular complains about

    # Replaces the deprecated `getDeclinedOptions` function
    $scope.getDeclinedPartnerOffers = ->
      CustomerApplicationService.getDeclinedPartnerOffers().then (response) ->
        resp = response.data

        # Map data from response to $scope vars
        $scope.avantPrequalDeclined = !!resp.avant_prequal_declined
        $scope.declinedOptions = resp.partner_offers || []
        $scope.hasPartnerOffers = !!$scope.declinedOptions.length
        # Make sure to only show credit score disclaimer if we're positive no hard inquiry was made
        $scope.hasHardInquiry = if resp.has_hard_inquiry == null then true else resp.has_hard_inquiry
        $scope.declinedReason = if resp.decline_reason == null then false else resp.decline_reason.declined_option
        $scope.hasSecurityFreeze = $scope.declinedReason in ['tu_security_freeze', 'experian_security_freeze']
        $scope.prefillConsents = {}
        $scope.setDeclinePageTitle()

        # Generate NOAA URL
        baseUrl = ConfigService.apiBaseUrl(ApplicationService.target_application_id())
        noaaUuid = resp.noaa_template_uuid
        $scope.viewNoaaUrl = "#{baseUrl}/notice_of_adverse_action?noaa_uuid=#{noaaUuid}"
        $scope.downloadNoaaUrl = "#{baseUrl}/download_notice_of_adverse_action?noaa_uuid=#{noaaUuid}"

        _.each $scope.declinedOptions, (option) ->
          partnerCode = option.data.partner_code
          option.partnerImg = $scope.partnerImgUrl[partnerCode]
          option.partnerImgAltText = $scope.partnerImgAltText[partnerCode] || "Partner logo"
          # We can't mark card_other_product_link as viewed
          #   because it's a link to an offer, not an actual offer.
          # Also shouldn't mark offer as viewed if it wasn't rendered due to
          #   security freeze view being shown instead of decline offers.
          if partnerCode != 'card_other_product_link' && !$scope.hasSecurityFreeze
            $scope.markOfferViewed(option.data.view_marked_link)
        # Track Page View
        $scope.trackVisit
          "declined_option": $scope.declinedOptions?[0]
          "partner_code": $scope.declinedOptions?[0]?.data?.partner_code || 'none'
        $scope.tealiumView($scope.tealiumDeclineTagName(), { application_page: $scope.page })
        true
      .catch ->
        # Track Page View
        $scope.trackVisit
          "error": true
      .finally -> $scope.loading = false

    ###############################################
    # DEPRECATED (still used in refi and Regions) #
    ###############################################
    # * Use `getDeclinedPartnerOffers` instead of `getDeclinedOptions`
    # * Use `viewPartnerOfferAndRedirect` instead of `viewPartnerOffer`
    # For future reference, to determine which partners are still using these legacy API calls,
    # search in `avant-basic > lib/customer_application_engine/` for `def new_decline_view?`
    # This is `false` globally, so any partner that doesn't specifically override it with `true`
    # is still using the legacy decline options code path.
    $scope.getDeclinedOptions = ->
      CustomerApplicationService.getDeclinedOptions().then (response) ->
        $scope.declinedOptions = response.data
        declinedReasons = _.map($scope.declinedOptions, (v)-> v.declined_option)

        $scope.declined_without_offer = do ->
          _.every(declinedReasons, (v) -> _.contains(['not_in_active_state', 'tu_security_freeze'], v))

        $scope.hasTransunionSecurityFreeze = declinedReasons?.includes('tu_security_freeze')
        $scope.hasPartnerOffers = $scope.declinedOptions.length && _.every($scope.declinedOptions, (v) -> v.declined_option == 'partner_offer')

        # Track Page View
        $scope.trackVisit
          "declined_option": $scope.declinedOptions?[0]
          "partner_code": $scope.declinedOptions?[0]?.partner_offer?.partner_code || 'none'
        $scope.tealiumView($scope.tealiumDeclineTagName(), { application_page: $scope.page })
        true
      .catch ->
        # Track Page View
        $scope.trackVisit
          "error": true
      .finally -> $scope.loading = false

    # DEPRECATED: Still used in pre-renderer products (UK, Regions) and renderer <= v2 (Eloan and Card)
    $scope.visitPartner = ($event, $index)->
      selected_partner = $scope.declinedOptions[$index]
      return unless selected_partner
      $scope.openUrl "/partner_offers/#{selected_partner?.partner_offer?.id}", true
      return false

    # DEPRECATED: I'm not sure this is used anywhere anymore
    $scope.viewPartnerOffer = ($event, declinedOption) ->
      return unless declinedOption
      $scope.openUrl declinedOption.data.initial_redirect_link
    ##########################
    # END DEPRECATED SECTION #
    ##########################


    # Determine whether to use legacy `declined_options` or newer declined partner offers
    if $scope.config.new_decline_view then $scope.getDeclinedPartnerOffers() else $scope.getDeclinedOptions()
]
